///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/filters/slug.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/settings.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/uid.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/i18n.ts" />
namespace TotalContest {
    import IAngularEvent = angular.IAngularEvent;
    import IScope = angular.IScope;
    import Controller = TotalCore.Common.Controller;
    import Slug = TotalCore.Common.Filters.Slug;
    import SettingsService = TotalCore.Common.Providers.SettingsService;
    import UniqueIdService = TotalCore.Common.Providers.UniqueIdService;
    import I18nService = TotalCore.Common.Providers.I18nService;

    @Controller('controllers.totalcontest')
    export class VoteFormFieldsCtrl {
        public categories = [];
        public fields;

        constructor(private $scope: IScope, private ajaxEndpoint, private prefix, private SettingsService: SettingsService, private UniqueIdService: UniqueIdService, private I18nService: I18nService) {
            this.fields = this.SettingsService.settings['contest'].vote.fields;
            $scope.fields = this.SettingsService.settings['contest'].vote.fields;
            $scope.$watch('fields', (fields) => {
                var fieldsNames = [];
                angular.forEach(fields, (field) => {
                    if (field.name.trim() === '') {
                        field.name = field.label || `untitled_${UniqueIdService.generate().substr(0, 4)}`;
                    }
                    field.name = Slug.filter(field.name, '_', true);
                    if (fieldsNames.indexOf(field.name) != -1) {
                        field.name = `${field.name}_copy}`;
                    }

                    fieldsNames.push(field.name);
                });
            }, true);
        }

        collapseFields() {
            this.setCollapsedForAll(true);
        }

        deleteField(index: number, ask: boolean = false, $event: IAngularEvent) {
            if (ask && !confirm(this.I18nService.__(['Are you sure?']))) {
                $event.stopPropagation();
                return false;
            }

            this.$scope.fields.splice(index, 1);
            return false;
        }

        deleteFields() {
            if (confirm(this.I18nService.__(['Are you sure?']))) {
                let fieldsCount = this.$scope.fields.length;
                for (let index = 0; index < fieldsCount; index++) {
                    this.$scope.fields.pop();
                }
            }
        }

        expandFields() {
            this.setCollapsedForAll(false);
        }

        generateName(field) {
            if (!field.name) {
                field.name = Slug.filter(field.label, '_');
            }
        }

        hasCategoryField() {
            for (let field of this.$scope.fields) {
                if (field.type === 'category') {
                    return true;
                }
            }
            return false;
        }

        insertField(args) {
            this.collapseFields();

            args = angular.extend({}, {
                uid: this.UniqueIdService.generate(),
                type: 'text',
                name: '',
                label: 'Field',
                defaultValue: '',
                options: '',
                collapsed: false,
                validations: {},
                attributes: {},
                template: '',
            }, args);

            this.$scope.fields.push(args);
        }

        isCollapsed(index) {
            return Boolean(this.$scope.fields[index].collapsed);
        }

        normalizeField(field) {
            if (angular.isArray(field.validations)) {
                field.validations = {};
            }

            if (angular.isArray(field.attributes)) {
                field.attributes = {};
            }
        }

        refreshCategories() {
            jQuery
                .get(
                    this.ajaxEndpoint,
                    {action: `${this.prefix}_contests_get_categories`}
                )
                .then((response) => {
                    this.$scope.$applyAsync(() => {
                        this.categories = response.data;
                    });
                });
        }

        setCollapsedForAll(collapsed) {
            this.$scope.fields.forEach(function (item) {
                item.collapsed = collapsed;
            });
        }

        toggle(index: number, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            this.$scope.fields[index].collapsed = !this.$scope.fields[index].collapsed;
            return false;
        }
    }

}
